import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

// material-ui
import { ButtonBase } from '@mui/material';

// project imports
import config from 'config';
// import Logo from 'ui-component/Logo';
// import logos from '../../../assets/images/logo.png'
import logos from '../../../assets/images/Cogency_Logo.png'
import { MENU_OPEN } from 'store/actions';

// ==============================|| MAIN LOGO ||============================== //

const LogoSection = () => {
  const defaultId = useSelector((state) => state.customization.defaultId);
  const dispatch = useDispatch();
  return (
    <ButtonBase disableRipple onClick={() => dispatch({ type: MENU_OPEN, id: defaultId })} component={Link} to="/admin/dashboard">
      {/* <Logo /> */}
    
       <img src={logos} alt='logo' width={120} style={{ marginLeft: 30 }}/>

    </ButtonBase>
  );
};

export default LogoSection;
